module.exports = __webpack_public_path__ + "static/media/eye.733b952f.svg";